export function toPayload(action) {
    return action.payload;
}
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/@ngrx/effects/src/util.js
// module id = g7ZR
// module chunks = 3